<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BaseSelect } from "@/components";

export default {
  name: "HistoryFilter",
  components: {
    BaseSelect,
  },
  data() {
    return {
      historyPeriod: null,
      historyRepresent: [
        {
          code: -1,
          label: "Tümü",
        },
      ],
      historyStatus: [
        {
          code: -1,
          label: "Tümü",
        },
      ],
      customerId: null,
    };
  },
  mounted() {
    this.customerId = this.$route.params.customerId;
    this.getFilter();
  },
  computed: {
    ...mapGetters(["getFilterList", "getHistoryFilter"]),
  },
  methods: {
    ...mapActions(["fillFilter", "getHistoryList", "postRepresentativeReport"]),
    ...mapMutations(["setHistoryFilter"]),
    getFilter() {
      this.fillFilter().then((res) => {
        if (res.data) {
          const packageHistoryStatusList = this.getFilterList.filter(
            (o) => o.name === "PackageHistoryStatus"
          )[0].values;

          packageHistoryStatusList.forEach((element) => {
            this.historyStatus.push(element);
          });

          this.postRepresentativeReport().then((data) => {
            if (data) {
              data.forEach((element) => {
                this.historyRepresent.push(element);
              });
            }
          });
        }
      });
    },
    changeHistoryStatus(value) {
      if (value.code != -1) {
        this.setHistoryFilter({
          page: 1,
          size: 100,
          filter: {
            HistoryPeriod: this.getHistoryFilter?.filter
              ? this.getHistoryFilter.filter?.HistoryPeriod
              : null,
            HistoryRepresentFullname: this.getHistoryFilter?.filter
              ? this.getHistoryFilter.filter?.HistoryRepresentFullname
              : null,
            HistoryStatus: value?.code.toString(),
          },
        });
      } else {
        delete this.getHistoryFilter.filter.HistoryStatus;
        this.setHistoryFilter(this.getHistoryFilter);
      }
      this.getHistoryList(this.customerId);
    },
    changeHistoryRepresent(value) {
      if (value.code != -1) {
        this.setHistoryFilter({
          page: 1,
          size: 100,
          filter: {
            HistoryPeriod: this.getHistoryFilter?.filter
              ? this.getHistoryFilter.filter?.HistoryPeriod
              : null,
            HistoryRepresentFullname: value,
            HistoryStatus: this.getHistoryFilter?.filter
              ? this.getHistoryFilter.filter?.HistoryStatus
              : null,
          },
        });
      } else {
        delete this.getHistoryFilter.filter.HistoryRepresentFullname;
        this.setHistoryFilter(this.getHistoryFilter);
      }
      this.getHistoryList(this.customerId);
    },
    changeHistoryPeriod(value) {
      let concatValue = value[0] + "&" + value[1];
      if (concatValue != ["null&null"]) {
        this.setHistoryFilter({
          page: 1,
          size: 100,
          filter: {
            HistoryPeriod: concatValue,
            HistoryRepresentFullname: this.getHistoryFilter?.filter
              ? this.getHistoryFilter.filter?.HistoryRepresentFullname
              : null,
            HistoryStatus: this.getHistoryFilter?.filter
              ? this.getHistoryFilter.filter?.HistoryStatus
              : null,
          },
        });
      } else {
        delete this.getHistoryFilter.HistoryPeriod;
        this.setHistoryFilter(this.getHistoryFilter);
      }
      this.getHistoryList(this.customerId);
    },
  },
};
</script>
<template>
  <div class="filter">
    <div class="form-group">
      <label for="historyPeriodFilter" class="form-control-label">Tarih</label>
      <date-picker
        v-model="historyPeriod"
        id="historyPeriodFilter"
        @change="changeHistoryPeriod"
        valueType="format"
        range
        placeholder="Tarih giriniz"
        :clearable="false"
        class="filter-datebox"
      />
    </div>
    <base-select
      :isSearchable="true"
      fieldLabel="Temsilci"
      :options="historyRepresent"
      id="historyRepresentFilter"
      placeholder="Temsilci Seçiniz"
      @change="changeHistoryRepresent"
      :clearable="false"
      class="filter-selectbox"
    />
    <base-select
      fieldLabel="İşlem Tipi"
      :options="historyStatus"
      id="historyStatusFilter"
      placeholder="İşlem Tipi Seçiniz"
      @change="changeHistoryStatus"
      :clearable="false"
      class="filter-selectbox"
    />
  </div>
</template>

<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 965px) {
    width: 100%;
    flex-flow: column;
    align-items: unset;
    .filter-selectbox {
      width: 100%;
    }
    .filter-datebox {
      width: 100%;
    }
  }
}
.form-group:not(:last-child) {
  margin-right: 16px;
}
.form-control-label {
  font-size: 12px;
  color: var(--grayscale-70);
}
</style>
<style lang="scss">
.filter {
  .form-control-label {
    font-size: 12px;
    color: var(--grayscale-70);
    position: relative;
    padding: 0 7px;
    margin-left: 10px;
    z-index: 2;
    top: 10px;
    background: #ffffff !important;
  }
  .mx-datepicker {
    display: block;
    &-range {
      width: 210px;
    }
    .mx-input {
      height: 47px;
      font-size: 14px;
      &::placeholder {
        color: #000 !important;
      }
    }
  }
  .vs__search {
    font-size: 14px !important;
  }
  @media (max-width: 965px) {
    .form-group {
      margin-right: 0 !important;
    }
  }
}
</style>

<style lang="scss">
.filter {
  .veri-dagitim-selectbox.v-select {
    background: white !important;

    .vs {
      &__dropdown-toggle {
        background: white !important;
      }
    }
  }
}
</style>
